module.exports = __webpack_public_path__ + "img/ch87.10f9232c.jpg";